// extracted by mini-css-extract-plugin
export default {"tableBodyCell":"TableBodyCell_tableBodyCell__4WvfZ","overflowedText":"TableBodyCell_overflowedText__R6tzT"};